if (typeof ''.repeat === 'undefined' || typeof Proxy === 'undefined') {
	alert('Your browser is not supported. Please upgrade to a modern browser.')
}

export {}
